
import React from 'react';
import PropTypes from 'prop-types';
import ListingButtons from '../components/listingButtons';
import { buildOpenHouseBar, displayListingPrice, buildComingSoonBar } from '../components/listingDetailsHelpers';
import { PrivateListingPopover } from './infoPopover';
import ReadMore from '../components/readMore';
import classNames from 'classnames';
import { getFormattedCurrency, getFormattedNumber, 
    colourNameToHex, lightenDarkenColor, 
    formatOpenHouseDates } from '../components/utils';

// images
import bed from '../images/icons/bed.svg';
import bath from '../images/icons/bath.svg';
import ruler from '../images/icons/ruler.svg';
import acres from '../images/icons/lotAcres.svg';
import calendar from '../images/icons/calendar.svg';
import nophoto from '../images/icons/nophoto.svg';
import heartIcon from '../images/icons/heart-new-filled-red-border-white.svg';
import thumbsDownIcon from '../images/icons/thumbsdown-filled-black-border-white.svg';
// svg icons
import {ReactComponent as Maybe} from '../images/svg_icons/maybe-selected.svg'
// styles
import '../scss/_listingCard.scss';

// viewMore property isn't used anymore but it's a way to pass data to the card to get it displayed in overlay. e.g viewMore="1 more"
// it has nothing to do with ReadMore. see commit for usage c597d69c23f054de5380f6dafafa6f4777185d33
class listingCard extends React.Component {
    render() {
        const { listing, viewMore, isListView, isMapPopup, listViewTable, onReadMoreClick, hideButtons = false } = this.props;
        const photo = (listing.ListingPhotosMidsize && listing.ListingPhotosMidsize[0]) || nophoto;
        var backgroundStyle = {
            backgroundImage: `url(${photo})`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
            backgroundPosition: `center`
        };
        const openHouseTime = formatOpenHouseDates(listing);
        const slashedPrice = <div className="listing_price_slashed">{getFormattedCurrency(listing.OriginalListPrice)}</div>;

        return <div className={classNames('listing_folder', {
                'listing_folder_stretch': isListView,
                'view_more': viewMore,
                'list-view-table': listViewTable
            })}
            role="button"
            tabIndex="0"
            data-after-content={viewMore}
            onKeyPress={(e) => { if (this.props.onClick && e.key === 'Enter') this.props.onClick(listing.Id) }}
            onClick={() => { if (this.props.onClick && viewMore) this.props.onClick(listing.Id) }}>
            <div className={isMapPopup ? "img_container cursor-pointer compact" : "img_container cursor-pointer"}
                onClick={() => { if (this.props.onClick) this.props.onClick(listing.Id) }}
                style={backgroundStyle}>
                {!isMapPopup &&
                    <div>
                        {listing && (listing.InterestLevel === 'Y' || listing.InterestLevel === 'N') &&
                            <div className="action_top_icons">
                                <img src={listing.InterestLevel === 'Y' ? heartIcon : thumbsDownIcon} alt="" />
                            </div>
                        }
                        {/* TODO combine above with this to use new SVG icons */}
                        {listing && listing.InterestLevel === 'M' &&
                            <div className="action_top_icons">
                                {/* <span className="imgicon maybe selected"> */}
                                <span>
                                    <Maybe />
                                </span>
                            </div>
                        }
                    </div>
                }
                <div className="listing-photo-flags">
                    <div className="badges">
                        {!isMapPopup &&
                            <div className={'listing_folder_flag status ' + listing.MlsStatus}
                                style={{ background: lightenDarkenColor(colourNameToHex(listing.StatusColor), 160), color: listing.StatusColor}}>
                                {listing.MlsStatus}
                            </div>
                        }
                        {openHouseTime &&
                            <div className="listing_folder_flag open-house">OPEN HOUSE</div>
                        }
                    </div>
                    {buildOpenHouseBar(listing, true)}
                    {buildComingSoonBar(listing, true)}
                </div>
            </div>
            <div className="listing_bottom">
                <div className="address" onClick={(e) => { if (this.props.onClick && e.target.nodeName !== 'BUTTON') this.props.onClick(listing.Id)}}>
                    <div className="display-if full-width">
                        <div className={isMapPopup?"map-address":"card-address"}>
                            <div className="addr-1">{listing.StreetAddress}</div>
                            <div className="addr-2">{listing.City}, {listing.State} {listing.Zip}</div>
                            <div className="mls-no">Listing ID: {listing.ListingId}
                                {listing.VisiblePrivateListing &&
                                    <React.Fragment>
                                        <div className="private-listing-flag">
                                            PRIVATE LISTING
                                        </div>
                                        <PrivateListingPopover id={listing.Id} />
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                        {!isMapPopup &&
                            <div className={!listing.PriceTypeLabel && listing.OriginalListPrice && listing.OriginalListPrice !== listing.ListPrice ? "listing_price" : "listing_price_grey"}>
                                {displayListingPrice(listing, true)}
                                {!listing.PriceTypeLabel && listing.OriginalListPrice && listing.OriginalListPrice !== listing.ListPrice ? slashedPrice : null}
                            </div>                        
                        }
                    </div>
                    {isMapPopup &&
                        <div>{displayListingPrice(listing)}</div>
                    }
                    {isListView &&
                        <div className="listing_remarks mg-top-15 d-none d-md-inline-block">
                            <ReadMore 
                                lines={2}
                                onReadMoreClick={onReadMoreClick ? () => onReadMoreClick(listing.Id): null}>
                                {listing.Remarks || ''}
                            </ReadMore>
                        </div>
                    }
                    <div className="listing_icons">
                        { listing.BedroomsTotal > 0 && <div><img src={bed} alt="bed" /> {listing.BedroomsTotal}</div> }
                        { listing.BathroomsFull > 0 && <div><img src={bath} alt="bath" /> {listing.BathroomsFull} </div> }
                        { listing.SquareFeet > 0 && <div><img src={ruler} alt="ruler" /> {getFormattedNumber(listing.SquareFeet)} sqft</div> }
                        {!isMapPopup && listing.YearBuilt && <div> <img src={calendar} alt="calendar" /> built {listing.YearBuilt}</div>}
                        {!isMapPopup && listing.PropertyType === "LL" && listing.Acres && listing.Acres > 0 && <div> <img src={acres} alt="acres" /> {listing.Acres} acres</div>}
                    </div>
                    {/* placeholder hack that maintains card width when no above icons or description */}
                    {/* {!isMobile && <div style={{ visibility: "hidden", height: "0px" }}>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                    </div>} */}
                </div>
                {/* key added because changing interest level on listViewTable would cause 
                    popover to stay open after listing changes, breaking the page when not found in the dom */}
                {!hideButtons && <ListingButtons key={listing.Id} {...this.props} showExtraButtons={false}></ListingButtons>}
            </div>
        </div>
    }
}

export default listingCard;

listingCard.propTypes = {
    listingActions: PropTypes.any.isRequired
};